/** Bimbingan-session mutations. */

import { createDoc, updateDoc } from '../service';
import { COL } from '../../collections';
import { utcNowIso } from '../../format';
import type { BimbinganSessionDoc } from '../../types';

export async function addBimbinganSession(data: {
  skripsiId: string;
  mahasiswaId: string;
  dosenId: string;
  type: 'proposal' | 'skripsi';
  bab?: string;
  materi: string;
  catatan?: string;
  status?: BimbinganSessionDoc['status'];
  sessionDate?: string;
}) {
  return createDoc<BimbinganSessionDoc>(COL.sessions, {
    ...data,
    status: data.status ?? 'menunggu',
    sessionDate: data.sessionDate ?? utcNowIso(),
  });
}

export async function updateSessionStatus(
  id: string,
  status: BimbinganSessionDoc['status'],
  feedback?: string,
) {
  return updateDoc<BimbinganSessionDoc>(COL.sessions, id, { status, feedback });
}
